(function () {
  if (window.__klPro) return;
  window.__klPro = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)').matches;

  function start() {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (reduce || root.classList.contains('kla-still')) return;
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);
    root.classList.add('kl-pro');

    /* Smooth scrolling (desktop only), kept in sync with ScrollTrigger */
    if (window.klProSmooth && desktop && window.Lenis) {
      var lenis = new window.Lenis({
        lerp: 0.1,
        smoothWheel: true,
        prevent: function (node) {
          return !!(node.closest && node.closest('cart-drawer, .drawer, [role="dialog"], .predictive-search, .kla-panel'));
        }
      });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);

      var locked = function () {
        var b = d.body;
        return b.classList.contains('overflow-hidden') || getComputedStyle(b).overflow === 'hidden';
      };
      var sync = function () { if (locked()) lenis.stop(); else lenis.start(); };
      new MutationObserver(sync).observe(d.body, { attributes: true, attributeFilter: ['class', 'style'] });
      sync();

      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a) return;
        var id = a.getAttribute('href');
        if (!id || id.length < 2) return;
        var t = null;
        try { t = d.querySelector(id); } catch (err) { return; }
        if (!t) return;
        e.preventDefault();
        lenis.scrollTo(t, { offset: -20, duration: 1.4 });
      });
    }

    /* Marquee: speeds up while the visitor scrolls */
    var track = d.querySelector('.kl-marquee__track');
    var anim = (track && track.getAnimations) ? track.getAnimations()[0] : null;
    if (anim) {
      var rate = { v: 1 };
      var setRate = function () { anim.playbackRate = rate.v; };
      ScrollTrigger.create({
        onUpdate: function (self) {
          var v = 1 + Math.min(Math.abs(self.getVelocity()) / 250, 7);
          gsap.to(rate, {
            v: v, duration: 0.2, overwrite: true, onUpdate: setRate,
            onComplete: function () { gsap.to(rate, { v: 1, duration: 1.2, onUpdate: setRate }); }
          });
        }
      });
    }

    /* Hero: content drifts and fades as you scroll away */
    var hero = d.querySelector('.kl-hero');
    if (hero) {
      var inner = hero.querySelector('.kl-hero__inner');
      if (inner) {
        gsap.to(inner, { yPercent: -10, opacity: 0.15, ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom 20%', scrub: true } });
      }
      gsap.to('.kl-orb--a', { y: -140, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to('.kl-orb--b', { y: 90, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }

    /* Spotlight: image reveals as it scrolls into view */
    var simg = d.querySelector('.kl-spot__img');
    if (simg) {
      gsap.fromTo(simg, { clipPath: 'inset(14% 10% 14% 10% round 30px)' },
        { clipPath: 'inset(0% 0% 0% 0% round 30px)', ease: 'none',
          scrollTrigger: { trigger: simg, start: 'top 92%', end: 'top 40%', scrub: 0.6 } });
      var inImg = simg.querySelector('img');
      if (inImg) {
        gsap.fromTo(inImg, { scale: 1.18 }, { scale: 1, ease: 'none',
          scrollTrigger: { trigger: simg, start: 'top 100%', end: 'bottom 30%', scrub: 0.6 } });
      }
    }

    /* Explore tiles: image parallax inside the tile + hover zoom */
    Array.prototype.forEach.call(d.querySelectorAll('.kl-tile'), function (tile) {
      var im = tile.querySelector('img');
      if (!im) return;
      gsap.fromTo(im, { yPercent: -7 }, { yPercent: 7, ease: 'none',
        scrollTrigger: { trigger: tile, start: 'top bottom', end: 'bottom top', scrub: true } });
      tile.addEventListener('mouseenter', function () { gsap.to(im, { scale: 1.08, duration: 0.8, ease: 'power3.out' }); });
      tile.addEventListener('mouseleave', function () { gsap.to(im, { scale: 1, duration: 0.8, ease: 'power3.out' }); });
    });

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  if (window.gsap && window.ScrollTrigger) start();
  else window.addEventListener('load', start);
})();
